import {
  initialState,
  Actions,
  State,
  GET_ALL_CUSTOM_CONTENT_TYPES,
  GET_ALL_CUSTOM_CONTENT_TYPES_SUCCESS,
  GET_ALL_CUSTOM_CONTENT_TYPES_ERROR,
  RESET_GET_ALL_CUSTOM_CONTENT_TYPES,
} from '../../types/custom-content-tye/get-all'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_CUSTOM_CONTENT_TYPES:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ALL_CUSTOM_CONTENT_TYPES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ALL_CUSTOM_CONTENT_TYPES_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ALL_CUSTOM_CONTENT_TYPES:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
